<div class="vat-disclaimer__plps">
  <span class="vat-disclaimer__plps__text">
    {{ 'CATALOG.VAT_DISCLAIMER' | translate}}
  </span>
  <app-tooltip
    [width]="16"
    [height]="16"
    [withBorders]="!isDesktop"
               [position]="isDesktop
               ? TOOLTIP_POSITION_DESKTOP
               : TOOLTIP_POSITION_MOBILE">
    <div
      [innerHTML]="'CATALOG.VAT_DISCLAIMER_TOOLTIP' | translate"
    ></div>
  </app-tooltip>
</div>
